import PendingIcon from "@/assets/colorable/pending.svg?react";
import TickIcon from "@/assets/colorable/tick_medium.svg?react";
import useCampaignManagementStore from "@/store/campaignManagement";
import {taskCompletedOnAtom} from "@/store/jotaiAtoms";
import {getContentIcons} from "@/utils/campaignUtils";
import dayjs from "dayjs";
import {useAtomValue} from "jotai";
import {times} from "lodash";
import {type FC} from "react";
import {useTranslation} from "react-i18next";
const PendingContents: FC<{
  count: number;
  taskCompletedDate?: string;
  title?: string;
  type: "POST" | "REEL" | "STORIES" | "TIKTOK_VIDEO" | "UGC";
}> = ({count, taskCompletedDate, title, type}) => {
  const {t} = useTranslation("content_approval");
  const isReportingTab = useCampaignManagementStore(state => state.tabState === "reporting");
  const taskCompletedOn = useAtomValue(taskCompletedOnAtom);
  const CONTENT_ICONS = getContentIcons();
  const Icon = CONTENT_ICONS[type];

  const taskCompletionDate = taskCompletedOn ?? taskCompletedDate;

  return times(count, index => (
    <div
      key={`${type}-${index}`}
      className="border-neutral-grey-light-dark flex h-fit w-fit min-w-70 flex-col gap-3 rounded-lg border p-3">
      {isReportingTab ? (
        taskCompletionDate && (
          <>
            <div className="flex justify-between gap-3">
              <div className="text-success-dark-green border-success-dark-green bg-success-light-green flex min-h-5 w-fit items-center gap-1 rounded-full border px-2">
                <TickIcon className="h-1.5 w-2" />
                <span className="text-2xs leading-3.5 font-semibold uppercase">{t("completed_admin")}</span>
              </div>
              <span className="text-2xs flex min-h-5 items-center justify-center rounded-full bg-black/80 px-2 text-center leading-3.5 font-semibold text-white uppercase">
                {dayjs(taskCompletionDate).format("DD.MM.YY")}
              </span>
            </div>
            <span className="text-neutral-black bg-neutral-grey-lightest border-primary-light-solid flex min-h-8 items-center justify-center rounded-md border px-2 py-1 text-xs">
              {t("marked_as_completed_by_an_admin")}
            </span>
          </>
        )
      ) : (
        <div className="text-neutral-black border-primary-sky bg-primary-powder flex min-h-5 w-fit items-center gap-1 rounded-full border px-2">
          <PendingIcon className="size-2.5" />
          <span className="text-2xs leading-3.5 font-semibold uppercase">{title ?? t("pending_submission")}</span>
        </div>
      )}
      <div className="bg-neutral-white-dark flex size-21.5 items-center justify-center rounded-sm">
        <Icon className="text-neutral-black size-4 shrink-0" />
      </div>
    </div>
  ));
};

export default PendingContents;
